import type {
  CreditProcessorPaymentAllocationEventListParametersType,
  CreditProcessorPaymentAllocationEventListResponseType,
} from "@sellar-io/api-v2/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2InfiniteQueryOptions,
  apiV2Request,
  getDefaultInfiniteQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCreditProcessorPaymentAllocationEvents = <
  TData = CreditProcessorPaymentAllocationEventListResponseType,
>(
  params: CreditProcessorPaymentAllocationEventListParametersType,
  options?: ApiV2InfiniteQueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useInfiniteQuery({
    queryKey: [
      user?.uid,
      business?.id,
      ServerStateKeys.CreditProcessorPaymentAllocationEvents,
      params,
    ],
    queryFn: ({ pageParam }) =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: "credit-processor/payment-allocation-events",
        params: {
          ...params,
          offset: pageParam || undefined,
        },
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultInfiniteQueryOptionsV2({
      context: { scope: "business", user, business },
      options: {
        ...options,
        limit: params.limit,
      },
    }),
  });
};
